export default __webpack_public_path__ + "static/media/eatnwatch_loading.de54b785.gif";